import React, { Component } from 'react'
import styles from './Search.module.css'

export class Search extends Component {
  render() {
    return (
      <div>
        <input className={styles.search} type="text" placeholder='Search for Movie Title...' />
      </div>
    )
  }
}

export default Search